import React from 'react';
import Container from 'components/UI/Container';
import Executive from './Executive';
import Leadership from './Leadership';
import { withErrorBoundary } from 'components/ErrorBoundary';
import { isRequestedFrom } from 'utils/localisation';
import { arabicRegion, euroMoneyRegion } from 'define/locale';
import { pushCustomEvent } from 'utils/analytics';

import * as styles from './ManagementBoard.module.scss';

function ManagementBoard() {
  const isSsr = typeof window === 'undefined';

  const handlePushEvent = (action, label) => {
    let options = { action };

    if (label) {
      options = { action, label };
    }
    pushCustomEvent('ndrsn_management_board', options);
  };

  if (!isSsr && isRequestedFrom([...arabicRegion, ...euroMoneyRegion, 'gb', 'us'])) {
    return (
      <Container
        id="managementBoard"
        className={styles.container}
        onClick={() => handlePushEvent('start_engage')}
      >
        <div className={styles.wrapper}>
          <Executive handlePushEvent={handlePushEvent} />
          <Leadership handlePushEvent={handlePushEvent} />
        </div>
      </Container>
    );
  }

  return null;
}

ManagementBoard.displayName = 'ManagementBoard';

export default withErrorBoundary(ManagementBoard);
